import Commons from './Common';
import Global from './Global';

export const buildFcmRequestItem = (
  { targetUserId, title, body, codeGroup, route, responseData },
  requestUserId
) => ({
  ResponseId: Commons.EncryptAES(targetUserId),
  Title: Commons.EncryptAES(title),
  Body: Commons.EncryptAES(body),
  FcmToken: Commons.EncryptAES(''),
  Gubun: Commons.EncryptAES(codeGroup),
  RequestId: requestUserId,
  Route: Commons.EncryptAES(route),
  ResponseData: Commons.EncryptAES(String(responseData ?? '')),
});

/** PostFcmServer — JSON body 배열 전송 (post1, 쿼리스트링 미사용) */
export const postFcmServer = async (payload) => {
  const result = await Commons.Axios(
    'post1',
    Global.base.useUrl + Global.urls.FCM.fcm,
    payload
  );
  const data = result.data;
  if (data && data.length > 0 && data[0].type === 'Error') {
    throw new Error(data[0].message);
  }
  return data;
};
